import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { InventoryEntity } from '../models/Inventory/InventoryEntity';
import { Router, NavigationExtras } from '@angular/router';
import { SearchHistoryEntity } from '../models/Transactions/SearchHistoryEntity';
import { TranslateService, TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-recently-searched',
    templateUrl: './recently-searched.component.html',
    styleUrls: ['./recently-searched.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [TranslateModule]
})
export class RecentlySearchedComponent implements OnInit {
  @Input() recentlySearched: SearchHistoryEntity[] = [];
  @Input() headerText: string;
  @Output() addEvent: EventEmitter<any> = new EventEmitter();
  public recentList: SearchHistoryEntity[];
  public header;
  constructor(private _ts: TranslateService) {

  }

  addData(data) {
    this.addEvent.emit([data]);
  }


  ngOnInit() {
    this.recentList = this.recentlySearched;
    this.header = this.headerText !== '' ? this.headerText : this._ts.instant('items.items');

  }
  AfterViewInit() {
    this.recentList = this.recentlySearched;
    this.header = this.headerText !== '' ? this.headerText : this._ts.instant('items.items');
  }



}
